import { Html5AppAction, Html5CreativesAction, Html5UploadAction } from './actions';

export enum Html5Page {
    ACTIVE = 'active',
    UPLOAD = 'upload',
    ARCHIVE = 'archive'
}

export type Html5Action = Html5AppAction | Html5CreativesAction | Html5UploadAction;
